export default __webpack_public_path__ + "static/media/about3.501a6cc8.png";